import { udLink } from '@udemy/ud-data';
import * as insightLinks from './insights/links';
export const PACKAGE_PLANS = {
  TEAM: 'Team',
  ENTERPRISE: 'Enterprise'
};
export const USER_ROLES = {
  OWNER: 'owner',
  ADMIN: 'admin',
  GROUP_ADMIN: 'group_admin',
  STUDENT: 'student'
};
export const UFB_ROUTES = {
  home: '/organization/home/',
  invite: '/organization-manage-v2/users/invite/',
  orgManageBillingPayment: '/organization-manage-v2/settings/billing/payment/',
  orgAdminOverview: '/organization-manage-v2/admin-overview/',
  adminLandingExperience: '/organization-manage-v2/'
};
export const ufbCourseDetailsInsights = courseId => `${insightLinks.absoluteForV2(insightLinks.toCourseDetails(courseId))}`;
export const BENESSE_BASE_URL = 'https://ufb.benesse.co.jp/';
export const UDEMYKOREA_BUSINESS_PATH = 'https://business.udemy.com/ko/';
export const UDEMYKOREA_BUSINESS_DEMO_PATH = 'https://business.udemy.com/ko/';
export const UDEMY_BUSINESS_PATH = '/udemy-business/';
export const BUSINESS_SIGNUP_URL = `${UDEMY_BUSINESS_PATH}sign-up/`;
export const UFB_TRIAL_EXTENSION_SIGN_UP_URL = `${BUSINESS_SIGNUP_URL}?ref=ufb_trial_extension_request`;
export const buyMoreLicensesLink = plan => {
  const links = {
    [PACKAGE_PLANS.TEAM]: '/organization-manage-v2/settings/billing/payment/',
    [PACKAGE_PLANS.ENTERPRISE]: udLink.toSupportLink('adding_more_licenses', true)
  };
  return links[plan];
};
export const HTTP_429_TOO_MANY_REQUESTS = 429;
export const RESOURCE_TYPES = Object.freeze({
  COURSE: 'course',
  LEARNING_PATH: 'learning_path',
  STARTER_PATH: 'starter_path',
  LAB: 'lab',
  ASSESSMENT: 'adaptive_assessment_assessment',
  BADGE_ASSERTION: 'badge_assertion',
  OPEN_BADGE: 'open_badge'
});
export const resourceRedirectURL = resourceId => ({
  [RESOURCE_TYPES.COURSE]: insightLinks.absolute(insightLinks.toCourseDetails(resourceId)),
  [RESOURCE_TYPES.LEARNING_PATH]: insightLinks.absolute(insightLinks.toPathDetails(resourceId)),
  [RESOURCE_TYPES.LAB]: insightLinks.absolute(insightLinks.toProInsights()),
  [RESOURCE_TYPES.ASSESSMENT]: insightLinks.absolute(insightLinks.toProInsights())
});
export const RESOURCE_URL_SLUGS = Object.freeze({
  [RESOURCE_TYPES.COURSE]: 'courses',
  [RESOURCE_TYPES.LEARNING_PATH]: 'paths',
  [RESOURCE_TYPES.LAB]: 'labs',
  [RESOURCE_TYPES.ASSESSMENT]: 'assessments',
  [RESOURCE_TYPES.BADGE_ASSERTION]: 'badge_assertions'
});
export const USER_CLASS = 'user';
export const ORGANIZATION_GROUP_CLASS = 'organization_group';
export const ALL_USERS_LABEL = 'all_users';
export const LICENSE_TYPE = Object.freeze({
  UNSPECIFIED: 0,
  ENTERPRISE: 1,
  PRO: 2
});
export const UTM_QUERY_PARAM_MKTO_FIELDS = {
  // Each [key] maps to a Query Param. It's value maps the Marketo field
  // E.g. ?utm_source=hi -> Campaign_Source_utm_source__c=hi
  utm_source: 'Campaign_Source_utm_source__c',
  utm_medium: 'Campaign_Medium_utm_medium__c',
  utm_campaign: 'CampaignID_utm_campaign__c',
  utm_content: 'Campaign_Content_utm_content__c',
  utm_term: 'Campaign_Term_utm_term__c',
  utm_method: 'Campaign_Method_utm_method__c',
  utm_region: 'Campaign_Region_utm_region__c'
};
export const LEARN_MORE = {
  get LINK() {
    return udLink.toSupportLink('course_retirements', true);
  }
};
export const KOREA_DEMO_REQUEST_PATHS = ['request-demo-mx', 'sign-up'];
//# sourceMappingURL=constants.js.map